import { FileText } from "lucide-react";
import { useLang } from "@/lib/lang";

export function getLibrarySearchHits(message) {
  if (message?.librarySearchResults?.length) {
    return message.librarySearchResults;
  }
  return (message?.citations || [])
    .filter((c) => c.kind === "library_hit")
    .map((c) => ({
      id: c.document_id,
      filename: c.filename,
      snippet: c.snippet,
      page: c.page,
      matches: c.matches,
      match_type: c.match_type,
      source_id: c.source_id,
    }));
}

export default function LibrarySearchResults({ hits = [], onOpenDocument }) {
  const { t } = useLang();

  if (!hits.length) {
    return (
      <div className="px-4 py-3 grid-border-t bg-slate-50/50 text-xs text-slate-500">
        {t("no_results")}
      </div>
    );
  }

  return (
    <div className="grid-border-t bg-slate-50/40" data-testid="library-search-results">
      <div className="px-4 py-2 grid-border-b">
        <span className="eyebrow !text-[9px]">{t("library_results")}</span>
        <span className="font-mono-tight text-[10px] text-slate-500 ms-2">{hits.length}</span>
      </div>
      <div className="divide-y divide-slate-200">
        {hits.map((hit, idx) => (
          <button
            key={hit.id || idx}
            type="button"
            data-testid={`library-search-hit-${hit.id}`}
            onClick={() => onOpenDocument?.(hit, idx + 1)}
            className="w-full text-start px-4 py-3 hover:bg-white transition-colors"
          >
            <div className="flex items-start gap-2">
              <FileText size={14} className="text-slate-400 mt-0.5 shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-sm font-medium text-slate-900 truncate">{hit.filename}</span>
                  {hit.matches != null && (
                    <span className="eyebrow !text-[9px]">
                      {hit.matches} {t("matches")}
                    </span>
                  )}
                  {hit.match_type && (
                    <span className="text-[10px] font-mono-tight bg-white px-1.5 py-0.5 grid-border">
                      {hit.match_type === "semantic" ? t("match_semantic") : t("match_keyword")}
                    </span>
                  )}
                  {hit.page && (
                    <span className="text-[10px] text-slate-500">
                      {t("viewer_page")} {hit.page}
                    </span>
                  )}
                </div>
                {hit.snippet && (
                  <p className="text-xs text-slate-600 leading-relaxed line-clamp-3">{hit.snippet}</p>
                )}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
